<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-shield"></i>
      <h3>Información del Aval</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-shield"></i>
      <p>No hay información de aval disponible</p>
    </div>

    <div *ngIf="hasData" class="data-sections">
      <!-- Indicador de Garantía -->
      <div class="section">
        <div class="guarantee-status" [class]="isComplete ? 'status-complete' : 'status-incomplete'">
          <div class="guarantee-header">
            <i class="pi" [class]="isComplete ? 'pi-check-circle' : 'pi-exclamation-triangle'"></i>
            <span class="guarantee-label">
              Estado del Aval: <strong>{{ isComplete ? 'Información Completa' : 'Información Incompleta' }}</strong>
            </span>
          </div>
          <div class="guarantee-description">
            {{ isComplete ? 
               'El aval cuenta con la información necesaria para validar la garantía.' : 
               'Se requiere información adicional para completar los datos del aval.' }}
          </div>
        </div>
      </div>

      <!-- Información Principal -->
      <div class="section">
        <h4 class="section-title">Información Principal</h4>
        <div class="data-grid">
          <div class="data-item featured" *ngIf="guarantorName !== 'No especificado'">
            <label>{{ guarantorType === 'company' ? 'Razón Social' : 'Nombre Completo' }}:</label>
            <span class="value guarantor-name" [class]="'type-' + guarantorType">
              {{ guarantorName }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.rfc">
            <label>RFC:</label>
            <span [class]="data?.rfc ? 'value' : 'placeholder'">
              {{ data?.rfc || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.curp" *ngIf="guarantorType === 'individual'">
            <label>CURP:</label>
            <span [class]="data?.curp ? 'value' : 'placeholder'">
              {{ data?.curp || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.clientType">
            <label>Tipo de Cliente:</label>
            <span [class]="data?.clientType ? 'value' : 'placeholder'">
              {{ data?.clientType || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Información de Contacto -->
      <div class="section">
        <h4 class="section-title">Información de Contacto</h4>
        <div class="data-grid">
          <div class="data-item featured" 
               *ngIf="fullAddress !== 'No especificado'"
               [class.empty]="fullAddress === 'No especificado'">
            <label>Dirección Completa:</label>
            <span class="value address-full">{{ fullAddress }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.phone">
            <label>Teléfono:</label>
            <span [class]="data?.phone ? 'value phone-number' : 'placeholder'">
              {{ formatPhone(data?.phone) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.extension" *ngIf="data?.extension">
            <label>Extensión:</label>
            <span class="value">{{ data?.extension }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.fax" *ngIf="data?.fax">
            <label>Fax:</label>
            <span class="value">{{ data?.fax }}</span>
          </div>
        </div>
      </div>

      <!-- Información Adicional -->
      <div class="section" *ngIf="data?.foreignState || data?.country">
        <h4 class="section-title">Información Adicional</h4>
        <div class="data-grid">
          <div class="data-item" [class.empty]="!data?.foreignState" *ngIf="data?.foreignState">
            <label>Estado Extranjero:</label>
            <span class="value">{{ data?.foreignState }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.country" *ngIf="data?.country">
            <label>País:</label>
            <span class="value">{{ data?.country }}</span>
          </div>
        </div>
      </div>

      <!-- Resumen de Garantía -->
      <div class="section">
        <h4 class="section-title">Resumen de Garantía</h4>
        <div class="guarantee-summary">
          <div class="summary-cards">
            <div class="summary-card type">
              <div class="card-icon">
                <i class="pi" [class]="guarantorType === 'company' ? 'pi-building' : 'pi-user'"></i>
              </div>
              <div class="card-content-summary">
                <div class="label">Tipo de Aval</div>
                <div class="value">{{ guarantorType === 'company' ? 'Persona Moral' : 'Persona Física' }}</div>
              </div>
            </div>

            <div class="summary-card status" [class]="isComplete ? 'complete' : 'incomplete'">
              <div class="card-icon">
                <i class="pi" [class]="isComplete ? 'pi-check' : 'pi-times'"></i>
              </div>
              <div class="card-content-summary">
                <div class="label">Estado</div>
                <div class="value">{{ isComplete ? 'Completo' : 'Incompleto' }}</div>
              </div>
            </div>

            <div class="summary-card completeness">
              <div class="card-icon">
                <i class="pi pi-chart-pie"></i>
              </div>
              <div class="card-content-summary">
                <div class="label">Completitud</div>
                <div class="value">{{ completionPercentage }}%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
